export const OpenInNewModalSVG = require("../../templates/partials/svg/icon_open_modal.svg");
